import React, { useState } from "react";
import ReviewPreview from "../../../common/ReviewPreview";
import RatingStars from "../../../common/RatingStars";
import { useQuery } from "@tanstack/react-query";
import { organizationReviewList } from "../../../../services/reviewService";
import { useDebounce } from "../../../../hooks/useDebounce";
import dayjs from "dayjs";

const HubReviews = ({ selectedProfile = {} }) => {
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);

  const { data: review } = useQuery({
    queryKey: ["review", selectedProfile?.value, filters, search],
    enabled: !!selectedProfile?.value,
    queryFn: async () => {
      const res = await organizationReviewList({
        referenceId: selectedProfile?.value,
        ...filters,
        ...(search && { keyword: search }),
      });
      return {
        ...res?.docs,
        data: res?.docs?.data?.map((r) => ({
          ...r,
          userAvatar: r?.userData?.image?.url,
          userName: `${r?.userData?.firstName || ""} ${
            r?.userData?.lastName || ""
          }`,
          isVerified: r?.status !== "pending",
          date: dayjs(r?.createdAt).format("MM/DD/YYYY"),
          comment: r?.message,
        })),
      };
    },
  });

  return (
    <>
      <div className="relative space-y-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-shrink flex-grow">
            <div className="font-semibold text-secondary text-xl">
              Customer Reviews
            </div>
            <div className="text-gray-500 text-sm">
              What our customers say about our events
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="py-1 px-8 bg-white shadow rounded-lg">
              <RatingStars
                rating={review?.data?.[0]?.avgRating || 0}
                showCount={true}
                totalReviews={review?.metadata?.totalDocs || 0}
                size="xl"
                alt
                align="center"
                ratingClass="!text-base"
                countClass="!text-sm"
              />
            </div>
          </div>
        </div>
        {review?.data?.length > 0 && (
          <div className="space-y-2">
            {review?.data?.map((review, index) => (
              <ReviewPreview
                key={index}
                review={review}
                classes={"!rounded-lg shadow !py-4 !px-4 !bg-white"}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default HubReviews;
